// src/components/Modal/Modal.jsx
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ open, onClose, children }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70">
      <div
        className="absolute inset-0"
        onClick={onClose}
      />
      <div className="relative z-10 bg-white rounded-lg overflow-hidden w-full max-w-6xl shadow-lg border border-gray-600">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-white bg-black rounded-full w-8 h-8 flex items-center justify-center z-20"
        >
          ✕
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
}
